import { jsx } from "react/jsx-runtime";
import { STEP_CONFIGS } from "./constants.js";
function StepHeader({ stepIndex, isEven, bleedPx = 0 }) {
  const config = STEP_CONFIGS[stepIndex];
  if (!config) return null;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "relative w-full",
      style: {
        height: config.barHeight + config.curveHeight,
        background: config.barColor
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            bottom: -1,
            left: isEven ? 0 : bleedPx,
            right: isEven ? bleedPx : 0,
            height: config.curveHeight + 1,
            background: "#ffffff",
            ...isEven ? { borderTopRightRadius: config.curveHeight } : { borderTopLeftRadius: config.curveHeight }
          }
        }
      )
    }
  );
}
export {
  StepHeader
};
//# sourceMappingURL=StepHeader.js.map
